// Shared style tokens for the standalone auth-style pages (signup, forgot/reset
// password, TpT arrival, email confirmation, change email) — all built on the
// same cream/navy palette. Individual pages override specific properties
// (margins, line-height, etc.) where their current design differs slightly.
export const authStyles = {
  heading: { fontSize: '24px', fontWeight: '700', color: '#1a1a2e', margin: '0 0 4px' },
  sub: { fontSize: '14px', color: '#6b6b7a', margin: '0 0 24px' },
  error: {
    backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px',
    padding: '12px 16px', fontSize: '14px', color: '#dc2626', marginBottom: '16px',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  label: { display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '14px', fontWeight: '500', color: '#374151' },
  input: {
    padding: '10px 12px', border: '1px solid #d9d4c5', borderRadius: '8px',
    fontSize: '15px', color: '#1a1a2e', backgroundColor: '#fff', outline: 'none',
  },
  button: {
    padding: '12px', backgroundColor: '#1a1a2e', color: '#fff', border: 'none',
    borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginTop: '8px',
  },
  footer: { textAlign: 'center', fontSize: '14px', color: '#6b6b7a', marginTop: '20px' },
  link: { color: '#c0392b', textDecoration: 'none', fontWeight: '500' },
};
